import _ from 'underscore';
import jQuery from 'jquery';

export default class ListHotelsProvider {
    constructor(conf, widget) {
        this.conf = _.extend({
            minLength: 1,
            maxResults: 5
        }, conf);
        this.widget = widget;
        this.providerName = 'ListHotelsProvider';
        this.widget.hotelMeliaList = [];
        this.load(widget);
    }

    load(widget) {
        this.widget.getDestinationsTreeObject(widget.config.initialDestinationId).then(hotels => {
            this.hotels = [];
            this.hotels.push(...hotels);
            this.hotelMeliaList = this.normalizeList(this.hotels);
        });
    }

    validate() {
        return true;
    }

    getPredictions(text) {
        if (typeof text !== 'string') {
            throw new Error('The text is missing');
        }

        let deferred = jQuery.Deferred();
        if (this.widget.hotelMeliaList.length > 1) {
            this.hotelMeliaList = this.normalizeList(this.widget.hotelMeliaList);
        }
        deferred.resolve(this.filterList(text).splice(0, this.conf.maxResults));
        return deferred.promise();
    }

    normalizeList(list) {
        return list.map(hotel => {
            return {
                code:  hotel.hotelCode,
                uid: hotel.uid,
                address: hotel.address,
                name: hotel.title,
                value: hotel.title,
                icon: 'melia-icon-ic-alternative',
                coords: hotel.position,
                provider: this.providerName
            }
        });
    }

    filterList(text) {
        return this.hotelMeliaList.filter(hotel => {
            return hotel.value.toUpperCase().indexOf(text.toUpperCase()) > -1;
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/autocomplete/providers/ListHotelsProvider.js